import React, { useState } from "react";

const MrutDakhala = () => {
  const [records, setRecords] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    fatherName: "",
    deathDate: "",
    deathPlace: "",
    causeOfDeath: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.deathDate) {
      alert("कृपया आवश्यक माहिती भरा.");
      return;
    }

    // नोंद यादीत जोडा
    setRecords([...records, { ...formData }]);

    // फॉर्म रिकामा करा
    setFormData({
      name: "",
      fatherName: "",
      deathDate: "",
      deathPlace: "",
      causeOfDeath: "",
    });
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>मृत्यू दाखला (Death Certificate)</h2>
      <p style={styles.description}>
        ग्रामपंचायतीकडून दिलेल्या मृत्यू प्रमाणपत्राची नोंद येथे केली जाते.
      </p>

      {/* ===== Form Section ===== */}
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="मृत व्यक्तीचे नाव"
          value={formData.name}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="fatherName"
          placeholder="वडिलांचे / पालकांचे नाव"
          value={formData.fatherName}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="date"
          name="deathDate"
          value={formData.deathDate}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="deathPlace"
          placeholder="मृत्यूचे ठिकाण"
          value={formData.deathPlace}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="text"
          name="causeOfDeath"
          placeholder="मृत्यूचे कारण"
          value={formData.causeOfDeath}
          onChange={handleChange}
          style={styles.input}
        />

        <button type="submit" style={styles.button}>
          नोंद जोडा
        </button>
      </form>

      {/* ===== Records Section ===== */}
      <div style={styles.listContainer}>
        <h3>📜 नोंदवलेले मृत्यू दाखले:</h3>
        {records.length === 0 ? (
          <p>अजून कोणतीही नोंद नाही.</p>
        ) : (
          <ul style={styles.list}>
            {records.map((record, index) => (
              <li key={index} style={styles.listItem}>
                <strong>{record.name}</strong> —{" "}
                {record.fatherName ? record.fatherName + " — " : ""}
                {record.deathDate} — {record.deathPlace} — {record.causeOfDeath}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f9f9f9",
    padding: "20px",
    minHeight: "100vh",
  },
  title: {
    color: "#8B0000",
    textAlign: "center",
  },
  description: {
    textAlign: "center",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "400px",
    margin: "0 auto",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 0 8px rgba(0,0,0,0.2)",
  },
  input: {
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  button: {
    backgroundColor: "#8B0000",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  listContainer: {
    marginTop: "30px",
  },
  list: {
    listStyle: "none",
    paddingLeft: 0,
  },
  listItem: {
    backgroundColor: "#fff",
    padding: "10px",
    marginBottom: "8px",
    borderRadius: "5px",
    boxShadow: "0 0 4px rgba(0,0,0,0.1)",
  },
};

export default MrutDakhala;